import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { of } from "rxjs";
import { AppConfigService } from "@master/core/dist/core";
import { map } from "rxjs/internal/operators/map";
import { catchError } from "rxjs/internal/operators";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class backendValidationService extends BaseService {
  constructor(
    private http: HttpClient,
    public appConfigService: AppConfigService
  ) {
    super(appConfigService);
  }
  
  getCapacities(dataTransport):Promise<string> {    
    return this.http.post(`${this.getUrl()}/capacity/definition`, dataTransport, { responseType: 'text'}).toPromise();        
  }
  //TODO: Test IMPORTANT
  checkIfPdfExists(url: string) {
    return this.http.head(url, { observe: 'response' }).pipe(
      map((response) => response.status === 200),
      catchError(() => of(false))
    );
  }

}
